import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import ModalCommon from 'components/Input/ModalCommon';
import Button from 'components/Button';
import { ErrorMessage, RetakeStudentStyled } from '../styled';
import { DatePicker, Divider, Spin } from 'antd';
import Input from 'components/Input/Input';
import Select from 'components/Select';
import CourseServices from 'services/CourseServices';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import dayjs from 'dayjs';
import { toolbarOptions3 } from 'assets/sheets/images';
import { validateForm } from 'helper/validation';
import CourseScheduleServices from 'services/CourseScheduleServices';
import { TIME_ZONE } from 'helper/init.constants';
import Editor from 'components/Editor/Editor';

const initateForm = {
  userId: '',
  name: '',
  email: '',
  userCode: '',
  courseId: '',
  eventId: '',
  createdAt: '',
  paymentMethod: '',
  days: Array(8).fill(''),
  notes: '',
};

export const statusSchedules = [
  {
    label: '受付済み',
    value: 'PAYMENT_COMPLETED',
  },
  {
    label: 'キャンセル待ち',
    value: 'CANCELLATION_WAITING_LIST',
  },
  {
    label: 'キャンセル',
    value: 'ADMIN_CANCELED',
  },
];

const AddMemberPopup = ({ isOpen, onCancel, onSuccess }) => {
  const noteRef = useRef(null)
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...initateForm });
  const [search, setSearch] = useState('');
  const [courses, setCourses] = useState([]);
  const [coursesId, setCoursesId] = useState([]);
  const [detailCourse, setDetailCourse] = useState({});
  const [resetKey, setResetKey] = useState(0);
  const [dateCreateAt, setDateCreateAt] = useState(false);

  // Add scroll listener to close DatePicker popups
  useEffect(() => {
    const handleScroll = () => {
      // Close all DatePicker popups when scrolling
      if (dateCreateAt) setDateCreateAt(false);
    };

    if (isOpen && dateCreateAt) {
      window.addEventListener('scroll', handleScroll, true);
      document.addEventListener('scroll', handleScroll, true);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [isOpen, dateCreateAt]);

  const handleAfterOpen = useCallback(() => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      modalBody.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    setResetKey((k) => k + 1);
  }, [isOpen]);

  const getDataUser = (search) => {
    setForm({
      ...form,
      userId: '',
      name: '',
      email: '',
      userCode: '',
    });
    if (search === '') {
      toast.error('データがありません');
      return;
    }
    CourseScheduleRegistationServices.getInfoUser({
      search: search,
    })
      .then((res) => {
        if (Array.isArray(res?.data?.items) && res?.data?.items.length !== 0) {
          const data = {
            ...res?.data?.items[0],
            name: `${res?.data?.items[0].name}`,
            userCode: res.data.items[0].memberId,
            userId: res.data?.items[0]._id,
          };
          setForm({
            ...form,
            ...data,
          });
          setErrors(
            errors.filter(
              (error) => !['userId', 'name', 'email'].includes(error.label)
            )
          );
        } else {
          toast.error('データがありません');
        }
      })
      .catch((err) => {
        toast.error(err?.message || err || NO_INTERNET);
      })
      .finally(() => setLoadingSearch(false));
  };

  const handleSearchStudent = () => {
    getDataUser(search);
  };

  useLayoutEffect(() => {
    if (!isOpen || loading) return;

    requestAnimationFrame(() => {
      const modalBody = document.querySelector('.ant-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    });
  }, [isOpen, loading]);

  const validations = [
    {
      label: 'userId',
      value: form.userId,
      rules: [
        {
          required: true,
          message: '会員IDを入力してください。',
        },
      ],
    },
    {
      label: 'name',
      value: form.name,
      rules: [
        {
          required: true,
          message: '名前を入力してください。',
        },
      ],
    },
    {
      label: 'email',
      value: form.email,
      rules: [
        {
          required: true,
          message: 'メールアドレスを入力してください。',
        },
      ],
    },
    {
      label: 'courseId',
      value: form.courseId,
      rules: [
        {
          required: true,
          message: 'コースを選択してください。',
        },
      ],
    },
    {
      label: 'eventId',
      value: form.eventId,
      rules: [
        {
          required: true,
          message: '開催IDを選択してください。',
        },
      ],
    },
    {
      label: 'createdAt',
      value: form.createdAt,
      rules: [
        {
          required: true,
          message: '申込日を選択してください。',
        },
      ],
    },
  ];

  const handleChangeData = ({ label, value }) => {
    setErrors(errors.filter((err) => err.label !== label));

    setForm({
      ...form,
      [label]: value,
    });

    if (label === 'courseId') {
      getCourseSchedule(value);
      if (value !== form.courseId) {
        setForm({
          ...form,
          courseId: value,
          eventId: '',
        });
      }
    }
  };

  const transformAttendance = (data) => {
    const days = Object.entries(data)
      .filter(([key]) => key.startsWith('date_attendance_'))
      .map(([key, value]) => {
        const day = Number(key.replace('date_attendance_', ''));
        return { day, status: value };
      });

    const newData = { ...data };
    delete newData.date_attendance_1;
    delete newData.date_attendance_2;

    return { ...newData, days };
  };

  const hasAnyAttendanceValue = (obj) =>
    Object.entries(obj).some(([key, value]) => {
      if (!key.startsWith('date_attendance_')) return false;

      return value !== null && value !== undefined && value !== '';
    });

  const addNewRetakeData = async () => {
    setLoading(true);

    CourseScheduleRegistationServices.addUserInCourse({
      eventId: form.eventId,
      form: transformAttendance({
        ...form,
        userId: form.userId,
        paymentMethod: 'UNDECIDED',
        status: 'WAITING_FOR_REGISTRATION',
        createdAt: form.createdAt,
        bindingText: 'PURCHASE',
        receiptRecipient: 'ALREADY_ISSUED',
        notes: (form.notes),
        type: 'RETAKE',
        days: form.days,
        timezone: TIME_ZONE,
      }),
    })
      .then((res) => {
        if (res.isOk) {
          toast.success('ユーザーの追加に成功しました');
          onCancel();
          setForm({ ...initateForm });
          setErrors([]);
          setSearch('');
          noteRef.current?.reset()
          onSuccess();
        }
      })
      .catch((err) => {
        toast.error(err?.message || err || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  };

  const handleValidRegisterCourse = async () => {
    setLoading(true);
    try {
      const res = await CourseScheduleServices.getDetail(form.eventId);
      if (res.isOk) {
        if (res.data?.retakeCapacity === 0) {
          toast.error('定員に達しているため、登録できません。');
          return false;
        }
        return true;
      }
      return false;
    } catch (error) {
      toast.error(error?.message || NO_INTERNET);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = async () => {
    const isValid = validateForm(form, validations, (errs) => setErrors(errs));

    const isValidStatus = hasAnyAttendanceValue(form);

    const isValidRegisterCourse = await handleValidRegisterCourse();

    if (!isValidStatus) {
      setErrors((errs) => [
        ...errs,
        {
          label: `date_attendance_${detailCourse?.schedule?.length}`,
          message:
            '再受講日程のいずれかのステータスを最低1つ選択してください。',
        },
      ]);
    }

    if (isValid.length === 0 && isValidStatus && isValidRegisterCourse) {
      addNewRetakeData();
    }
  };

  const getCourseSchedule = useCallback(
    (id) => {
      CourseScheduleRegistationServices.getCourseSchedules(id)
        .then((res) => {
          setCoursesId(
            res?.data?.items.map((item) => ({
              label: item.eventId,
              value: item._id,
            }))
          );
        })
        .catch((err) => toast.error(err?.message || NO_INTERNET))
        .finally(() => setLoading(false));
    },
    [form.courseId]
  );

  const getCourses = useCallback(() => {
    setLoading(true);
    CourseServices.getCourses()
      .then((res) => {
        setCourses(
          res.data
            .map((item) => ({
              value: item._id,
              label: item.name,
            }))
            .map((i) =>
              i.label === 'インテグレーティッドトレーニング'
                ? {
                  value: i.value,
                  label: 'インテグレーティッド',
                }
                : i
            )
        );
        setTimeout(() => {
          noteRef.current?.reinitSnapshot()
        }, 100)
      })
      .catch((err) => {
        toast.error(err?.message || err || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  }, [isOpen]);

  const getCourseRegistrationById = useCallback(() => {
    setLoading(true);
    CourseScheduleRegistationServices.getCourseRegistrationById()
      .then((res) => {
        if (res.isOk) {
          setCoursesId(
            res?.data?.items?.map(
              (item) =>
                ({
                  value: item._id,
                  label: item.eventId,
                }) || []
            )
          );
        }
      })
      .catch(() => toast.error(NO_INTERNET))
      .finally(() => setLoading(false));
  }, []);

  const getDetailCourseSchedule = useCallback(() => {
    setLoading(true);
    form.eventId && CourseScheduleServices.getDetail(form.eventId)
      .then((res) => {
        if (res.isOk) {
          setDetailCourse(res?.data || []);
        }
      })
      .catch((err) => toast.error(err?.message || NO_INTERNET))
      .finally(() => setLoading(false));
  }, [form.eventId]);

  useEffect(() => {
    getCourses();
    getCourseRegistrationById();
  }, []);

  useEffect(() => {
    if (isOpen !== undefined) {
      isOpen && getCourseRegistrationById();
    }
  }, [isOpen, getCourseRegistrationById]);

  useEffect(() => {
    isOpen && getDetailCourseSchedule();
  }, [isOpen, getDetailCourseSchedule]);

  const handleChangeDate = ({ label, value }) => {
    setErrors(errors.filter((err) => err.label !== label));
    setForm({
      ...form,
      [label]: dayjs.isDayjs(value) ? dayjs(value).format('YYYY/MM/DD') : '',
    });
  };

  return (
    <RetakeStudentStyled>
      <Spin spinning={false}>
        <ModalCommon
          onAfterOpen={handleAfterOpen}
          title="個別追加"
          open={isOpen}
          onCancel={() => {
            onCancel();
            setForm({ ...initateForm });
            setErrors([]);
            noteRef?.current?.reset()
            setSearch('');

          }}
          width={600}
          heightHeader={56}
          footer={
            <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
              <Button
                btnType="back"
                onClick={() => {
                  onCancel();
                  setForm({ ...initateForm });
                  setErrors([]);
                  noteRef.current.reset()
                  setSearch('');
                }}
                height={40}
                width={120}
                fontSize={14}
              >
                キャンセル
              </Button>
              <Button
                type="primary"
                onClick={handleAddUser}
                fontSize={14}
                loading={loading}
                height={40}
                width={120}
              >
                <p style={{ letterSpacing: '0' }}>追加</p>
              </Button>
            </div>
          }
        >
          <div className="flex w-full items-center justify-between">
            <Input
              placeholder={'名前、メールアドレス、会員ID'}
              width={390}
              height={40}
              value={search}
              onChange={(e) => setSearch(e)}
            />
            <Button
              width={84}
              height={40}
              btnType="outline"
              onClick={handleSearchStudent}
              loading={loadingSearch}
            >
              <p style={{ letterSpacing: '0' }}>検索</p>
            </Button>
          </div>

          <Divider className="m-0" />
          <Input
            title="userId"
            label="会員ID"
            format="memberId"
            required
            disabled
            $autoTrim={true}
            errors={errors}
            widthInput={390}
            heightInput={38}
            widthLabel={136}
            value={form.userCode}
            $paddingMessage={152}
          />

          <Input
            title="name"
            label="名前"
            required
            disabled
            $autoTrim={true}
            widthInput={390}
            heightInput={38}
            errors={errors}
            widthLabel={136}
            value={form.name}
            $paddingMessage={152}
          />
          <Input
            title="email"
            label="メールアドレス"
            required
            disabled
            $autoTrim={true}
            errors={errors}
            widthInput={390}
            heightInput={38}
            widthLabel={136}
            value={form.email}
            $paddingMessage={152}
          />
          <Select
            title="courseId"
            label="コース"
            required
            $autoTrim={false}
            rules={[{ required: true, message: '名前を入力してください' }]}
            widthSelect={390}
            heightSelect={40}
            widthLabel={136}
            errors={errors}
            options={courses}
            value={form.courseId}
            onChange={(e) =>
              handleChangeData({ label: 'courseId', value: e.value })
            }
            $paddingMessage={152}
          />

          <Select
            title="eventId"
            label="開催ID"
            required
            $autoTrim={false}
            rules={[{ required: true, message: '名前を入力してください' }]}
            widthSelect={390}
            heightSelect={40}
            widthLabel={136}
            errors={errors}
            options={[...coursesId]}
            value={form.eventId}
            onChange={(e) =>
              handleChangeData({ label: 'eventId', value: e.value })
            }
            $paddingMessage={152}
          />

          <div className="flex items-center gap-4">
            <span className="w-[136px] text-sm">
              申込日<span className="ml-1 text-red-500">*</span>
            </span>
            <div className="flex w-[390px] flex-col items-start justify-start">
              <DatePicker
                format="YYYY/MM/DD"
                placeholder="yyyy/mm/dd"
                onOpenChange={(open) => {
                  requestAnimationFrame(() => {
                    window.dispatchEvent(new Event('resize'));
                  });
                  setDateCreateAt(open);
                }}
                open={dateCreateAt}
                className={`h-10 w-full xl:h-8 xl:rounded-[4px] 2xl:h-9 ${errors.filter((e) => e.label === 'createdAt').length > 0 ? 'border-[#ff4d4f] shadow-error' : ''}`}
                getPopupContainer={(trigger) => trigger.parentNode}
                value={form.createdAt ? dayjs(form.createdAt) : null}
                onChange={(date) =>
                  handleChangeDate({ label: 'createdAt', value: date })
                }
              />
              <ErrorMessage
                $paddingMessage={152}
                message={
                  errors?.find((err) => err.label === 'createdAt')?.message ||
                  null
                }
              >
                {errors?.find((err) => err.label === 'createdAt')?.message}
              </ErrorMessage>
            </div>
          </div>

          {[...Array(8)].map((_, index) => (
            <Select
              key={index}
              title={`date_attendance_${index + 1}`}
              label={`受講日(${index + 1}日目)`}
              $autoTrim={false}
              rules={[{ required: true, message: '名前を入力してください' }]}
              widthSelect={390}
              heightSelect={40}
              widthLabel={136}
              errors={
                Array.isArray(errors) &&
                  detailCourse?.schedule &&
                  Array.isArray(detailCourse?.schedule) &&
                  detailCourse?.schedule?.length === index + 1
                  ? errors
                  : []
              }
              disabled={
                !detailCourse?.schedule ||
                !detailCourse.schedule
                  ?.map((item) => item.day)
                  ?.includes(index + 1)
              }
              options={statusSchedules}
              value={form[`date_attendance_${index + 1}`]}
              onChange={(e) =>
                handleChangeData({
                  label: `date_attendance_${index + 1}`,
                  value: e.value,
                })
              }
              $paddingMessage={152}
            />
          ))}

          <Editor
            ref={noteRef}
            label={'備考'}
            title="notes"
            alignLabel="center"
            widthLabel={136}
            options={[toolbarOptions3]}
            widthEditor={390}
            heightEditor={200}
            resetKey={resetKey}
            value={form.notes}
            onChange={handleChangeData}
          />
        </ModalCommon>
      </Spin>
    </RetakeStudentStyled>
  );
};

export default AddMemberPopup;
